export enum EventType {
    corporateEvent = 'corporate_event',
    professionalHoliday = 'professional_holiday',
    stateHoliday = 'state_holiday'
}